import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import FormsList from '../forms/CompletedForms/FormsList';

export default function BoardCardForms({
  id,
  topOffset = 0,
}) {
  const forms = useSelector((state) => state.forms.forms);

  const formsList = useMemo(() => Object.values(forms).filter((form) => {
    const { cardId: formCardId, subtaskCardId } = form;
    return formCardId === id || subtaskCardId === id;
  }), [forms, id]);

  const query = useMemo(() => ({ cardId: id }), [id]);

  return (
    <div style={{ paddingTop: '10px' }}>
      <FormsList
        topOffset={240 + topOffset}
        forms={formsList}
        hideDate
        query={query}
      />
    </div>
  );
}
